import React from 'react';
import { Coffee, Twitter } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export function Footer() {
  const { isDarkMode } = useTheme();
  
  return (
    <footer className={`py-6 text-center ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
      <div className="flex flex-col items-center gap-4">
        <p className="text-sm flex items-center justify-center gap-2">
          Crafted with 
          <span className="inline-block transition-all duration-500 hover:scale-125 hover:rotate-12 hover:text-red-500 cursor-default group relative">
            ❤️
            <span className="absolute -top-1 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 group-hover:-translate-y-2 transition-all duration-500">
              ✨
            </span>
          </span>
        </p>
        
        <div className="flex items-center gap-4">
          <a
            href="https://x.com/souptikdn"
            target="_blank"
            rel="noopener noreferrer"
            className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-all duration-300 hover:scale-105 ${
              isDarkMode 
                ? 'hover:bg-white/10 text-gray-400 hover:text-white' 
                : 'hover:bg-black/5 text-gray-600 hover:text-black'
            }`}
          >
            <Twitter size={16} />
            <span className="text-sm">Follow me</span>
          </a>
          
          <a
            href="https://buymeacoffee.com/souptikdn"
            target="_blank"
            rel="noopener noreferrer"
            className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-all duration-300 hover:scale-105 ${
              isDarkMode 
                ? 'hover:bg-yellow-500/10 text-gray-400 hover:text-yellow-400' 
                : 'hover:bg-yellow-500/10 text-gray-600 hover:text-yellow-600'
            }`}
          >
            <Coffee size={16} />
            <span className="text-sm">Buy me a coffee</span>
          </a>
        </div>
      </div>
    </footer>
  );
}